import styled from "styled-components";

const LoginWrapper = styled.div`
.MuiInputBase-input{
  width: 91% !important;
}
`;

export default LoginWrapper;
